// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {

  apiKey: "AIzaSyDUH22tYyMFpjhF1cDS42hOt_b22pBYRvI",

  authDomain: "react-blog-f149f.firebaseapp.com",

  projectId: "react-blog-f149f",

  storageBucket: "react-blog-f149f.firebasestorage.app",

  messagingSenderId: "369433733321",

  appId: "1:369433733321:web:c03b88ab8e9fd646d28518",

  measurementId: "G-5CG8Q189FP"

};
;

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Get Auth instance
const auth = getAuth(app);

export { auth };